import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { PostAdminV1OrgProductsBody } from '@nucleus-commerce/api-client/admin';

import { productsApi } from '../api/products-api';

import { productKeys } from './product-keys';

/** Errors (field errors, missing required attributes) are rendered by the form, not toasted. */
export function useCreateProduct() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: PostAdminV1OrgProductsBody) => productsApi.create(input),
    meta: { successMessage: 'products:toasts.created', silentError: true },
    onSuccess: (product) => {
      queryClient.setQueryData(productKeys.detail(product.id), product);
      return Promise.all([
        queryClient.invalidateQueries({ queryKey: productKeys.lists() }),
        queryClient.invalidateQueries({ queryKey: productKeys.vendors() }),
      ]);
    },
  });
}
